export enum FileType {
    IMAGE="IMAGE", PDF = "PDF", SCALED_IMAGE = "SCALED_IMAGE"
}
